//#region src/modules/AppWrapper2/components/AppNav/nav-background.ts
/**
* Header tint for the active app ("Tactical Steel" design handoff): a
* left-anchored horizontal wash of the app's accent hue over the surface
* color, fading to transparent by 16% of the bar's width — kept short so it
* reads as a corner accent rather than bleeding across the whole header. A
* matching right-anchored wash mirrors it at 1/3 the width (fading out by
* ~5.33%) so the corner accent reads on both ends without being symmetric.
*
* The wash is derived from the app's tile color via CSS relative color
* syntax: lightness is fixed per stop (0.50 → 0.46) and chroma is scaled
* from the tile's (×1.3 → ×1.1), which reproduces the handoff's per-app
* tint stops from the single source color (e.g. ADMIN's C 0.10 tile yields
* the specified 0.13/0.11 stops). Alpha stops are constant per the
* handoff: 0.50 → 0.13 → 0. The right wash's edge stop is deliberately
* dimmer (0.30) than the left's (0.50) so it reads as a lighter touch.
*/
function navBackground(accentColor) {
	if (!accentColor) return void 0;
	const strong = `oklch(from ${accentColor} 0.50 calc(c * 1.3) h / 0.50)`;
	const mid = `oklch(from ${accentColor} 0.46 calc(c * 1.1) h / 0.13)`;
	return { background: `linear-gradient(90deg, ${strong} 0%, ${mid} 9%, transparent 16%), linear-gradient(270deg, ${`oklch(from ${accentColor} 0.50 calc(c * 1.3) h / 0.30)`} 0%, ${mid} 3%, transparent 5.33%), var(--color-surface-strong)` };
}
//#endregion
export { navBackground };

//# sourceMappingURL=nav-background.js.map